import { InputNumber, InputText } from '../../../components/Inputs/Boxes'
import { ButtonLink } from '../../../components/Inputs/Buttons'
import Filtro from '../../../consulta/Filtrado/Filtro/Filtro'
import TituloFiltro from '../../../modules/turno/components/TituloFiltro'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { invitadoVacio } from '../utils/constants/invitado.constants'

const AgregarInvitado = ({invitados, setInvitados, topeInvitados, estadoAgregando, setEstadoAgregando}) => {

    const [invitado, setInvitado] = useState(invitadoVacio)

    const agregarInvitado = () => {
        setEstadoAgregando(true)
    }

    const cancelarInvitado = () => {
        setEstadoAgregando(false)
        setInvitado(invitadoVacio)
    }

    const finalizarAgregarInvitado = () => {
        if(invitados.find(inv => inv.dni === invitado.dni)) {
            toast.info("Ya existe un invitado con ese DNI")
            return;
        }
        if(!invitado.dni) {
            toast.info("Debe ingresar un DNI")
            return; 
        }
        if(!invitado.nombre.length) {
            toast.info("Debe ingresar un nombre")
            return; 
        }
        if(!invitado.apellido.length) {
            toast.info("Debe ingresar un apellido")
            return; 
        }
        if(!invitado.edad.length) {
            toast.info("Debe ingresar una edad")
            return; 
        }
        setInvitados([...invitados, invitado]);
        setEstadoAgregando(false)
        setInvitado(invitadoVacio)
    }

    const handleAtributo = (e) => {
        const {name, value} = e.target;
        setInvitado(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    return (
        <div className="pl-2 mt-2">

            {
                !estadoAgregando &&
                <ButtonLink
                    onClick={agregarInvitado}
                >
                    Agregar invitado
                </ButtonLink>
            }

            {
                invitados.length == topeInvitados &&
                <p className=" text-center text-danger">Ya llegó al tope de invitados</p>
            }

            {
                estadoAgregando && invitados.length < topeInvitados &&
                <>

                    <TituloFiltro className="text-center">Agregar invitado</TituloFiltro>

                    <Filtro
                        label="DNI"
                    >
                        <InputNumber
                            value={invitado.dni}
                            onChange={handleAtributo}
                            name="dni"
                        />
                    </Filtro>

                    <Filtro
                        label="Nombre"
                    >
                        <InputText
                            value={invitado.nombre}
                            onChange={handleAtributo}
                            name="nombre"
                        />
                    </Filtro>
                    
                    <Filtro
                        label="Apellido"
                    >
                        <InputText
                            value={invitado.apellido}
                            onChange={handleAtributo}
                            name="apellido"
                        />
                    </Filtro>

                    <Filtro
                        label="Edad"
                    >
                        <InputNumber
                            value={invitado.edad}
                            onChange={handleAtributo}
                            name="edad"
                        />
                    </Filtro>

                    {
                        invitados.length < topeInvitados &&
                        <div className="pl-2 mt-3 text-center">

                            <ButtonLink
                                onClick={cancelarInvitado}
                                color="secondary"
                            >
                                Cancelar
                            </ButtonLink>

                            <ButtonLink
                                onClick={finalizarAgregarInvitado}
                                className="ms-2"
                            >
                                Agregar invitado (Tope {topeInvitados})
                            </ButtonLink>

                        </div>   
                    }

                </>
            }

        </div>
    )
}

export default AgregarInvitado